import clsx from "clsx";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@components";
import { updateUserOrganization } from "./helpers/updateUserOrganization";
import * as constants from "./helpers/constants";

export default function OrgSignUp() {
    const [orgName, setOrgName] = useState("");
    const [dropdownValue, setDropdownValue] = useState("");
    const [btnDisabled, setBtnDisable] = useState(true);
    const [displayErrMsg, setDisplayErrMsg] = useState(null);

    const { user } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();

    const onSubmit = async () => {
        try {
            const token = localStorage.getItem("token");
            const validRequest =
                user.email && token && orgName && dropdownValue;

            if (validRequest) {
                await updateUserOrganization(
                    user.email,
                    token,
                    orgName,
                    dropdownValue,
                );

                const redirectTo = location.state?.redirectTo || "/";
                navigate(redirectTo);
            }
            if (!validRequest) {
                setDisplayErrMsg(constants.errMsg);
            }
        } catch (error) {
            console.log("Org Sign Up Error:", { error });
            setDisplayErrMsg(`You got the following server error: ${error}`);
        }
    };

    useEffect(() => {
        if (dropdownValue && orgName) {
            setBtnDisable(false);
        }

        if (!orgName || !dropdownValue) {
            setBtnDisable(true);
        }
    }, [dropdownValue, orgName]);

    return (
        <div className={parentContainer}>
            <div className="mb-8 text-2xl font-semibold">
                Register Your Organization
            </div>
            <div className="mb-8 max-w-[400px]">
                It looks like you don't have an organization saved to your
                account. Please submit the following items in order to gain and
                retain access to CTrees' projects.
            </div>
            <div className="flex w-[400px] flex-col gap-4">
                <input
                    type="text"
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    placeholder="Organization Name*"
                    className="w-full rounded border p-2"
                />
                <select
                    value={dropdownValue}
                    onChange={(e) => setDropdownValue(e.target.value)}
                    className="w-full rounded border p-2"
                >
                    <option value="" disabled default>
                        Category*
                    </option>
                    {constants.orgCats.map((cat) => (
                        <option value={cat.value}>{cat.display}</option>
                    ))}
                </select>
                <Button
                    disabled={btnDisabled}
                    onClick={onSubmit}
                    className="rounded text-white"
                >
                    Submit
                </Button>
            </div>
            <div className="mt-2 text-red">{displayErrMsg}</div>
        </div>
    );
}

const parentContainer = clsx(
    "w-full h-screen flex flex-col justify-center items-center",
);
